export default __webpack_public_path__ + "images/navigation_M.png";